import { useMemo, useReducer, useState } from 'react'
import { withRouter } from 'next/router'
import PropTypes from 'prop-types'
import { environment } from '@dmi-mch/utils'

import { initialState, reducer, StateContext } from '../contexts/EventsContext'

/**
 * @returns {JSX.Element}
 * @constructor
 */

function ModuleProvider({ children, CMSProps, router }) {
  // Ask/Add in this array for any other labels you need from the Labels System
  const [hydratedInitialState] = useState({
    CMSProps,
    labels: null,
    events: null,
    filters: null,
    router,
    paginationInfo: null,
    isLoadingEvents: false,
    isLoadingNewpage: false
  })

  useMemo(() => {
    if (JSON.stringify(Object.keys(hydratedInitialState).sort()) !== JSON.stringify(Object.keys(initialState).sort())) {
      environment.isNotPro &&
        // eslint-disable-next-line no-console
        console.error(
          'Attention, the initial state configured here and the one declared in' +
            ' ../contexts/module does not match. Remember to update and to add the explanation of what is, what for, ' +
            'and where is used, inside module context file. Thanks! :)'
        )
    }
  }, [hydratedInitialState])

  return (
    //@ts-ignore
    <StateContext.Provider value={useReducer(reducer, hydratedInitialState)}>{children}</StateContext.Provider>
  )
}

ModuleProvider.propTypes = {
  children: PropTypes.node,
  props: PropTypes.object,
  router: PropTypes.object,
  CMSProps: PropTypes.object
}

export default withRouter(ModuleProvider)
